import { render, staticRenderFns } from "./PageOnboarding.vue?vue&type=template&id=35c24a70"
import script from "./PageOnboarding.vue?vue&type=script&lang=js"
export * from "./PageOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports